import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
} from "react";
import styled from "styled-components";
import { Tab } from "../../Reusablecomponents/Tab";
import {
  Badge,
  Button,
  Col,
  Row,
  Avatar,
  Checkbox,
  Popover,
  Tooltip,
  Space,
  Form,
  message,
  Spin,
  Select,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import {
  ButtonFilled,
  ButtonOutlined,
  Buttontransparent,
} from "../../Reusablecomponents/UIButtons";
import { StyledTable } from "../../Reusablecomponents/UITable/UITable";
import { ReactComponent as CopyIcon } from "../../assets/images/Vector.svg";
import { ReactComponent as EditIcon } from "../../assets/images/Editicon.svg";
import { ReactComponent as Gps } from "../../assets/images/gps-svgrepo-com.svg";
import { ReactComponent as DeleteIcon } from "../../assets/images/delete-icon.svg";
import FilterIcon from "../../assets/images/Filter-Icon.svg";
import SortIcon from "../../assets/images/sort-svgrepo-com.svg";
import ImportIcon from "../../assets/images/download1.svg";
import ExportIcon from "../../assets/images/export-svgrepo-com (1).svg";
import GridBuilder from "../../UIBuilderEngine/GridBuilder";
import ReusableDrawer from "../../Reusablecomponents/ReusableDrawer";
import UIModal from "../../Reusablecomponents/UIModal";
import TripCode from "../../containers/TrackRightAI/tripDetailsAI";
import { CALL_API } from "../../Common/api";
import { useSelector } from "react-redux";
import {
  PanTripTypeEnum,
  priorityType,
  TripTypeEnum,
  AITripStatusEnum,
  shipmentType,
} from "../../Common/constant";
import moment from "moment";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";
import { render } from "@testing-library/react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { ReactComponent as Track } from "../../assets/images/gps-svgrepo-com.svg";
import ReusablePagination from "../../Reusablecomponents/ReusablePagination";
export const WrapperBox = styled.div`
  background-color: white;
  padding: 15px;
  border-radius: 8px;
  .consingment_container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #5f6d8c;
    font-weight: 400;
    font-size: 16px;
    line-height: 19.36px;
  }
  .FilterIcon {
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    // border-radius:50%;
    background-color: #ebf7ed !important;
    margin-left: 10px;
  }

  @media (max-width: 320px) {
    .consingment_container {
      display: flex;
      align-items: center;
      flex-direction: column;
      color: #5f6d8c;
    }
    .consingment_container_two {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin: 20px 0px 08px 0px;
    }
    .ant-tabs-nav .ant-tabs-nav-list {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin: 20px 0px 08px 0px;
    }
  }
  .consingment_container_two {
    display: flex;
    align-items: center;
  }
  p {
    margin-bottom: 0px;
    line-height: 0px;
    font-size: 16px;
    font-weight: 400;
  }
  .Create_btn {
    width: 150;
    height: 38;
    gap: 8px;
    border-width: 1px;
    border: none;
    outline: none;
    border-radius: 26px;
    padding: 9px 16px;
    font-weight: 500;
    font-size: 16px;
    background-color: rgb(44, 150, 61) !important;
    color: white !important;
  }

  .Creating_Consignment {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px 0px 10px 0px;
    border-bottom: 1px solid rgb(231 231, 237);
    padding: 8px 7px 15px 8px;
  }
  .ant-badge.ant-badge-status .ant-badge-status-dot {
    width: 12px;
    height: 12px;
  }
  .badg {
    padding: 6px;
  }

  .modal_container_forfiltermenu {
    display: flex;
    justify-content: space-between;
    margin: 7px 14px 7px 0px;
  }
  .flilter_five {
    font-weight: 500;
    font-size: 20px;
    line-height: 24.2px;
  }
  .Custom {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .checkbox_group_container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .checkbox_group_container .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #28a745; /* green */
    border-color: #28a745;
  }

  .checkbox_group_container .ant-checkbox:hover .ant-checkbox-inner {
    border-color: #28a745;
  }

  .checkbox_group_container
    .ant-checkbox-indeterminate
    .ant-checkbox-inner::after {
    background-color: #28a745;
  }
`;
const TableStyle = styled.div`
  .inactive-status {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #e4a400;
  }

  .status {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #2c963d;
  }

  .yellow-dot {
    width: 4px;
    height: 4px;
    background-color: #e4a400;
    border-radius: 50%;
  }
`;

const TripListAI = () => {
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const updateAllowed = useMemo(
    () => hasPermission("TRIPAI", "ET"),
    [reduxPermissions],
  );
  const deleteAllowed = useMemo(
    () => hasPermission("TRIPAI", "DT"),
    [reduxPermissions],
  );
  const exportAllowed = useMemo(
    () => hasPermission("TRIPAI", "EX"),
    [reduxPermissions],
  );
  const AIVehicleLists = useSelector(
    (state) => state?.authTracking?.AIVehicleLists,
  );
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);

  const handleTrackClick = (record) => {
    localStorage.setItem("selectedRecord", JSON.stringify(record));
    window.open(
      `/TrackLinkAI/${record.TRIPID}?vehId=${record.VehId}&shipmentTypeId=${record.ShipmentType}&mcId=${userInfo?.MCID}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const csvLinkEl = useRef();

  const vehicleList = useSelector((state) => state?.authTracking?.vehicleList);
  const vehicleLists = useSelector(
    (state) => state?.authTracking?.vehicleLists,
  );
  const fenceList = useSelector((state) => state?.authTracking?.fenceList);
  const [customFields, setCustomFields] = useState([]);
  const [isconfigModalVisible, setIsconfigModalVisible] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null); // To store the ID of the consignment to delete
  const [deleteloading, setDeleteLoading] = useState(false);
  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );
  const location = useLocation();

  const [form] = Form.useForm();

  useEffect(() => {
    const duration = form.getFieldValue("duration");

    if (duration === "last_month") {
      form.setFieldValue("daterange", [
        dayjs().subtract(1, "month").startOf("month"),
        dayjs().subtract(1, "month").endOf("month"),
      ]);
      setFormData((PrevValue) => ({
        ...PrevValue,
        ["daterange"]: [
          dayjs().subtract(1, "month").startOf("month"),
          dayjs().subtract(1, "month").endOf("month"),
        ],
      }));
    } else if (duration === "current_month") {
      form.setFieldValue("daterange", [
        dayjs().startOf("month"),
        dayjs().endOf("month"),
      ]);
      setFormData((PrevValue) => ({
        ...PrevValue,
        ["daterange"]: [dayjs().startOf("month"), dayjs().endOf("month")],
      }));
    } else if (duration === "current_year") {
      form.setFieldValue("daterange", [
        dayjs().startOf("year"),
        dayjs().endOf("year"),
      ]);
      setFormData((PrevValue) => ({
        ...PrevValue,
        ["daterange"]: [dayjs().startOf("year"), dayjs().endOf("year")],
      }));
    } else if (duration === "today") {
      form.setFieldValue("daterange", [dayjs(), dayjs()]);
      setFormData((PrevValue) => ({
        ...PrevValue,
        ["daterange"]: [dayjs(), dayjs()],
      }));
    } else if (duration === "---") {
      form.setFieldValue("daterange", [null, null]);
      setFormData((PrevValue) => ({
        ...PrevValue,
        ["daterange"]: [null, null],
      }));
    }
  }, [form.getFieldValue("duration")]);

  const [visibleExport, setVisibleExport] = useState(false);
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const [visibleSort, setVisibleSort] = useState(false);
  const handleTooltipVisibleChangeExport = (visible) => {
    setVisibleExport(visible);
    hideTooltipArrow();
  };
  const handleTooltipVisibleChangeSort = (visible) => {
    setVisibleSort(visible);
    hideTooltipArrow();
  };
  const hideTooltipArrow = () => {
    setTimeout(() => {
      const tooltipArrows = document.querySelectorAll(".ant-tooltip-arrow");
      tooltipArrows.forEach((arrow) => {
        arrow.style.display = "none";
      });
    }, 0);
  };

  const [consignee, setConsignee] = useState(null);
  const [hoveredrow, setHoveredrow] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tripList, setTripList] = useState([]);
  const [tripId, setTripId] = useState(null);
  const [ShipmentId, setShipmentId] = useState(null);
  const [VEHID, setVehId] = useState(null);
  const [formData, setFormData] = useState({
    duration: "current_month",
    daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
  });
  const [assignedCount, setAssignedCount] = useState([]);
  const [completedCount, setCompletedCount] = useState([]);
  const [inProgressCount, setInProgreeCount] = useState([]);
  const [filterCount, setFilterCount] = useState(0);
  const handleChange = (e) => {
    const { value, name } = e.target;
    setCurrentPage(1);
    setFormData((PrevValue) => ({ ...PrevValue, [name]: value }));
  };
  const [isEditing, setIsEditing] = useState(false);
  const showDrawer = () => {
    setIsEditing(false);
    setFormData({
      consignor: "",
      transporter: "",
      consignee: "",
      chargetype: "",
      priority: "",
      noofdeliverables: "",
      dimension: "",
      gross: "",
      switch: "",
      plocation: "",
      pdate: "",
      dlocation: "",
      ddate: "",
      pnotes: "",
      dnotes: "",
      remark: "",
      linkdossier: "",
      orderno: "",
      referenceno: "",
      containerno: "",
      zone: "",
    });
    setDrawerOpen(true);
  };

  useEffect(() => {});

  useEffect(() => {
    if (location.state?.from === "ConsignmentAI" && location.state?.tripId) {
      setTripId(location.state.tripId);
      setVehId(location.state.vehId);
      setShipmentId(location.state.ShipmentId);
      setConsignee(true);
      setSelectededittwo(location.state?.consignmentRecord);
    }
  }, [location.state]);

  const editUser = (record) => {
    setIsEditing(true);
    setDrawerOpen(true);
    setEditformdata({
      ...record,
      triptype: record?.Triptype,
      odostart: record?.ODOSTART,
      odoend: record?.ODOEND,
      remarks: record?.REMARKS,
      finalquantity: "",
      tripallowance: "",
    });
  };

  const handleClickme = (record) => {
    setHoveredrow(record.key);
  };

  const [showModal, SetshowModal] = useState(false);

  const [resolveModal, setResolveModal] = useState(false);

  const handleclickme = () => {
    SetshowModal(true);
  };

  const handlecancelmodal = () => {
    SetshowModal(false);
  };

  const closeEditModal = () => {
    setResolveModal(false);
  };
  const editModuleupdate = () => {
    // form.resetFields();
    setFormData({
      driver: "",
      consignor: "",
      vehicle: "",
      consignee: "",
      fence: "",
      transporter: "",
      consignmentevent: "",
      ReferenceNo: "",
      tripcode: "",
      triptype: "",
      duration: "current_month",
      daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
    });
    form.setFieldsValue({
      driver: "",
      consignor: "",
      vehicle: "",
      consignee: "",
      fence: "",
      transporter: "",
      consignmentevent: "",
      ReferenceNo: "",
      tripcode: "",
      triptype: "",
      duration: "current_month",
      daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
    });
  };
  const [sortField, setSortField] = useState(null);

  const [formType, setFormType] = useState("addEdit"); // 'addEdit' or 'bulkCreate'

  const handleCreateClick = () => {
    setFormType("addEdit");
    setDrawerOpen(true);
  };

  //custome data Get All function
  const [AllCustomeData, SetAllCustomeData] = useState([]);

  const GetAllCustomeData = async () => {
    // setLoading(true);
    try {
      const { data } = await CALL_API(
        "GET",
        `mastertable/GetAllCustomeData?MCID=${userInfo?.MCID}&REFTAB=Trip`,
      );

      SetAllCustomeData(data);
    } catch (error) {
      console.error("Error fetching custom data", error);
    } finally {
      setLoading(false);
    }
  };

  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  //http://127.0.0.1:3000/ai/trip/getAllTrip
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const fetchTripListData = async () => {
    try {
      setLoading(true); // Start the spinner
      const { data } = await CALL_API("POST", `ai/trip/getAllTrip`, {
        mcId: userInfo?.MCID,
        driver: formData?.driver || "",
        custName: formData?.consignor || "",
        regNo: formData?.vehicle || "",
        recName: formData?.consignee || "",
        fId: formData?.fence || "",
        supName: formData?.transporter || "",
        status: formData?.consignmentevent,
        ReferenceNo: formData?.ReferenceNo || "",
        code: formData?.tripcode || "",
        tripType: formData?.triptype || 0,
        dateFrom:
          dayjs(formData?.daterange?.[0]).format("YYYY-MM-DD") ||
          moment(new Date()).format("YYYY-MM-DD"),
        dateTo:
          dayjs(formData?.daterange?.[1]).format("YYYY-MM-DD") ||
          moment(new Date()).format("YYYY-MM-DD"),
        offset: currentPage,
        perPage: pageSize,
        sortColumns: sortColumns,
      });
      const newData1 = data?.data?.map((tripItem) => {
        const enrichedItem = { ...tripItem };

        // Match fields by REFID === TRIPID
        const matchedFields =
          AllCustomeData?.filter((field) => field.REFID === tripItem.TRIPID) ||
          [];

        matchedFields.forEach((field) => {
          enrichedItem[field.CFID] = field.VALUE;
        });

        return enrichedItem;
      });
      setTripList(newData1 || []);
      setAssignedCount(data?.assignedCount || 0);
      setInProgreeCount(data?.inProgressCount || 0);
      setCompletedCount(data?.completedCount || 0);
      setTotal(data?.totalCount || 0);
    } catch (error) {
      console.error("Error fetching trip list data:", error);
      message.error("Failed to fetch trip list data.");
    } finally {
      setLoading(false); // Stop the spinner only after data is processed
    }
  };

  const prepareCSV = async (event, done) => {
    try {
      setCSVLoader(true);
      const { data } = await CALL_API("POST", `ai/trip/getAllTrip`, {
        mcId: userInfo?.MCID,
        driver: formData?.driver || "",
        custName: formData?.consignor || "",
        regNo: formData?.vehicle || "",
        recName: formData?.consignee || "",
        fId: formData?.fence || "",
        supName: formData?.transporter || "",
        code: formData?.tripcode || "",
        // tripType: formData?.triptype || "",
        tripType: formData?.triptype || "",
        status: formData?.consignmentevent,
        ReferenceNo: formData?.ReferenceNo || "",
        dateFrom:
          dayjs(formData?.daterange?.[0]).format("YYYY-MM-DD") ||
          moment(new Date()).format("YYYY-MM-DD"),
        dateTo:
          dayjs(formData?.daterange?.[1]).format("YYYY-MM-DD") ||
          moment(new Date()).format("YYYY-MM-DD"),
        offset: 1,
        perPage: total,
      });
      setCSVLoader(false);
      if (data?.data?.length > 0) {
        setCSVList(
          data?.data?.map((item) => ({
            Date: item.Started ? dayjs(item.Started).format("DD/MM/YYYY") : "-",
            "Consign Code": item.CODE || item.Code || "-",
            Priority: item.Priority === 1 ? "High" : "Normal",
            "Vehicle/Driver": `${item.VehRegNo || "-"} / ${
              item.DriverName || "-"
            }`,
            Device: item.DeviceName,
            "Consignment Count": item.ConsignmentCount,
            "Shipment Type":
              shipmentType.find((s) => s.value === item.ShipmentType)?.name ||
              "-",
            Status:
              AITripStatusEnum.find((s) => s.value === item.STATUS)?.label ||
              "-",
            Consignor: item.CustName || "-",
            Transporter: item.SupName || "-",
            Consignee: item.FNAME || "-",
            "ODO(KMS)": item.gpskms || 0,
            "Carbon Footprint": item.CarbonFootprint || "-",
            "Delivery Note Number": item.FWayBill || "-",
            "Reference No": item.ReferenceNo || "-",
            "Container No": item.ContainerNo || "-",
          })),
        );

        setTimeout(() => {
          csvLinkEl.current.link.click();
        });
      } else {
        message.error("No data available to download.");
      }
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };

  //Custome Field api calling Function

  const loadCustomFields = async () => {
    // setLoading(true);
    try {
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: "Trip",
        RefId: 0,
        Active: 1,
        McId: userInfo?.MCID,
      });
      setCustomFields(data);
    } catch (error) {
      setCustomFields();
      console.error("Error fetching custom fields:", error);
    } finally {
      setLoading(false);
    }
  };

  //Update custom data api call functionality
  const CustomeDataUpdate = async (TRIPID, values) => {
    setLoading(true);
    try {
      for (const field of customFields) {
        const fieldName = field.FIELDNAME.replace(/\s+/g, "_").toLowerCase();
        const value = values?.[fieldName];

        const existing = AllCustomeData?.find(
          (item) => item.REFID === TRIPID && item.CFID === field.CFID,
        );

        if (value !== undefined && value !== "" && existing) {
          const payload = {
            CfId: field.CFID,
            RefId: TRIPID,
            Value: value,
            DataId: existing.DATAID,
          };
          await CALL_API("PATCH", "mastertable/updateCustomData", payload);
        }
      }
    } catch (error) {
      console.error("Error updating custom fields:", error);
    } finally {
      setLoading(false);
    }
  };

  //Delete custom data api call functionality
  const CustomeDataDelete = async (TRIPID) => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "DELETE",
        `mastertable/deleteCustomDataByRef`,
        {
          RefId: TRIPID,
          RefTab: "Trip",
          McId: userInfo?.MCID,
        },
      );
    } catch (error) {
      console.error("Error deleting custom field:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleclickdeleteAi = async (id) => {
    setDeleteLoading(true);

    try {
      const { ResponseCode, message: apiMessage } = await CALL_API(
        "DELETE",
        `ai/trip/deleteTrip/${id}`,
      );

      if (ResponseCode === 200) {
        await fetchTripListData();
        setConsignee(false);
        setIsDeleteModalVisible(false);
        setDeleteId(null);
        message.success(apiMessage || "Trip Deleted Successfully");
      }
    } finally {
      setDeleteLoading(false);
    }
  };

  const [sortFields, setSortFields] = useState([]);
  const [sortColumns, setSortColumns] = useState([]);
  const getFieldType = (type) => {
    const typeMap = {
      1: "selectwithvalue", // Dropdown
      2: "text", // Textbox
      3: "checkbox", // Checkbox
    };
    return typeMap[type] || "text";
  };

  const chunkArray = (arr, size = 3) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      const row = arr.slice(i, i + size);
      while (row.length < size) {
        row.push({}); // Empty field to maintain layout
      }
      chunks.push(row);
    }
    return chunks;
  };
  const dynamicCustomColumns = useMemo(() => {
    if (!customFields || customFields.length === 0) return [];

    return customFields.map((field) => ({
      title: field.FIELDNAME,
      dataIndex: field.CFID,
      key: field.CFID,
      sorter: false,
      render: (text) => text || "-",
    }));
  }, [customFields]);
  const columns = [
    {
      title: "Date",
      dataIndex: "Started",
      key: "Started",
      render: (value) => {
        return value ? dayjs(value).format("DD/MM/YYYY") : "---";
      },
    },
    {
      // title: "Trip Code",
      title: "TRIP CODE",
      dataIndex: "CODE",
      key: "CODE",
      // sorter: sortFields?.includes("CODE") // remove leading space!
      //   ? (a, b) => (a.CODE ?? 0) - (b.CODE ?? 0)
      //   : false,
      // render: (text, record) => {
      //   return (
      //     <div>
      //       <p>{text}</p> {/* Render the Trip Code */}
      //       <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
      //         <span
      //           style={{
      //             width: "4px",
      //             height: "4px",
      //             borderRadius: "50%",
      //             backgroundColor:
      //               record?.TripType === 1 ? "#5F6D8C" : "#E4A400", // Local: Default color, Safari: #E4A400
      //           }}
      //         ></span>
      //         <span
      //           style={{
      //             color: record?.TripType === 1 ? "#5F6D8C" : "#E4A400", // Local: Default color, Safari: #E4A400
      //             fontStyle: record?.TripType === 1 ? "italic" : "normal", // Italic for Local, normal for Safari
      //           }}
      //         >
      //           {tripList?.TripType === 1 ? "Local" : "Safari"}
      //         </span>
      //       </div>
      //     </div>
      //   );
      // },

      render: (text, record) => {
        return (
          <div>
            <p>{text}</p> {/* Render the Trip Code */}
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <span
                style={{
                  width: "4px",
                  height: "4px",
                  borderRadius: "50%",
                  backgroundColor:
                    record?.Triptype === 1 ? "#5F6D8C" : "#E4A400", // Local: blueish, Safari: yellow
                }}
              ></span>
              <span
                style={{
                  color: record?.Triptype === 1 ? "#5F6D8C" : "#E4A400",
                  fontStyle: record?.Triptype === 1 ? "italic" : "normal",
                }}
              >
                {record?.Triptype === 1
                  ? "Local"
                  : userInfo?.MCID === 72
                    ? "Transit"
                    : "Safari"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      title: "Vehicle/Driver",
      dataIndex: "VehRegNo",
      key: "VehRegNo",
      // sorter: sortFields?.includes("VehRegNo")
      //   ? (a, b) => a.VehRegNo?.localeCompare(b.VehRegNo)
      //   : false,
      render: (text, record) => {
        return (
          <div>
            {record?.VehRegNo || "-"} <br /> {record?.DriverName || "-"}
          </div>
        );
      },
    },
    {
      title: "Device",
      dataIndex: "DeviceName",
      key: "DeviceName",
      render: (text) => {
        return text ? text : "-";
      },
    },
    {
      title: "Status",
      dataIndex: "STATUS",
      key: "STATUS",
      render: (status, record) => {
        return (
          <div
            onClick={(e) => {
              e.stopPropagation();
              handleTrackClick(record);
            }}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              cursor: "pointer",
            }}
          >
            {/* Status Label */}
            <span style={{ color: status === 4 ? "green" : "#E4A400" }}>
              {AITripStatusEnum.find((item) => item.value === status)?.label ||
                "-"}
            </span>

            {/* Track Icon and Text for In Progress and Completed */}
            {status === 3 || status === 4 ? (
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <Track
                  onClick={(e) => {
                    e.stopPropagation();
                    handleTrackClick(record);
                  }}
                  style={{ cursor: "pointer" }}
                />
                <span style={{ color: "#2C963D" }}>Track</span>
              </div>
            ) : (
              <span style={{ color: "#5F6D8C" }}></span>
            )}
          </div>
        );
      },
    },
    {
      title: "Consign",
      dataIndex: "ConsignmentCount",
      key: "ConsignmentCount",
      render: (text) => {
        return text ? text : "-";
      },
    },
    {
      title: "Shipment Type",
      dataIndex: "ShipmentType",
      key: "ShipmentType",
      render: (text) => {
        if (text === 1) return "Delivery";
        if (text === 2) return "Collection";
        return "-";
      },
    },
    {
      title: "Consignor",
      dataIndex: "CustName",
      key: "CustName",
      // sorter: sortFields?.includes("CustName")
      //   ? (a, b) => a.CustName?.localeCompare(b.CustName)
      //   : false,
    },
    {
      title: "Odometer (ODO)",
      dataIndex: "gpskms",
      key: "gpskms",
    },
    {
      title: "Transporter",
      dataIndex: "SupName",
      key: "SupName",
      // sorter: sortFields?.includes("SupName")
      //   ? (a, b) => a.SupName?.localeCompare(b.SupName)
      //   : false,
    },
    {
      title: "Carbon Footprint",
      dataIndex: "CarbonFootprint",
      key: "CarbonFootprint",
      render: (text) => {
        return text ? text : "-";
      },
    },
    {
      title: "Delivery Note Number",
      dataIndex: "FWayBill",
      key: "FWayBill",
      // sorter: sortFields?.includes("FWayBill")
      //   ? (a, b) => a.FWayBill?.localeCompare(b.FWayBill)
      //   : false,
      render: (text) => {
        return text ? text : "-";
      },
    },
    {
      title: "Container No",
      dataIndex: "ContainerNo",
      key: "ContainerNo",
      render: (text) => {
        return text ? text : "-";
      },
    },
    // ...(userInfo?.MCID === 72
    //   ? [
    {
      title: "Reference No",
      dataIndex: "ReferenceNo",
      key: "ReferenceNo",
      // sorter: sortFields.includes("ReferenceNo")
      //   ? (a, b) => a.ReferenceNo.localeCompare(b.ReferenceNo)
      //   : false,
    },
    //   ]
    // : []),
    {
      title: "Actions",
      key: "actions",
      width: "15%",
      render: (_, record) => (
        <div
          className={
            hoveredrow === record.key ? "d-flex gap-3 opacity-100" : "opacity-0"
          }
        >
          {/*
          <Tooltip title={!updateAllowed ? "No permission" : ""}>
          <EditIcon
                  style={{ cursor: updateAllowed ? "pointer" : "not-allowed", marginLeft: "10px" }}
                  onClick={(e) => {
                    if (!updateAllowed) return;
                    e.stopPropagation();
                    setFormData({
                      chargetype: record?.ChargeType,
                      consignor: consignerList?.find(
                        (item) => item?.Name === record?.CustName,
                      )?.ID,
                      ddate: dayjs(record?.DropOffDateTime),
                      dropoffnotes: record?.DropOffNote,
                      dlocation: record?.EndLocation,
                      gross: record?.GrossVolume,
                      GrossWeight: record?.GrossWeight,
                      switch: record?.ISDELOTP,
                      pdate: dayjs(record?.PickUpDateTime),
                      pickupnotes: record?.PickUpNote,
                      priority: record?.Priority,
                      transporter: transporterList?.find(
                        (item) => item?.Name === record?.SupName,
                      )?.ID,
                      remark: record?.Remarks,
                      // consignee: consigneeList?.find(
                      //   (item) => item?.Name === record?.RecName
                      // )?.ID, // Map consignee to its ID
                      consignee: null,
                      fence: fenceList?.find((item) => item?.FGUID === record?.FID)
                        ?.FName,
                      plocation: record?.StartLocation,
                      TripId: record?.TripId,
                      CrBy: record?.CrBy,
                      ConsignId: record?.ConsignId,
                      EndLat: record?.EndLat,
                      EndLng: record?.EndLng,
                      switch: false,
                      StartLat: record?.StartLat,
                      StartLng: record?.StartLng,
                      dimension: record?.dimension,
                      deliverables: record?.noofdeliverables,
                      ReferenceNo: record?.ReferenceNo,
                      ContainerNo: record?.ContainerNo,
                    });
                    setIsEdit(true);
                    setDrawerOpen(true);
                  }}
                /> 
                </Tooltip>
                */}
          <Tooltip title={!deleteAllowed ? "No permission" : ""}>
            <DeleteIcon
              style={{
                cursor: deleteAllowed ? "pointer" : "not-allowed",
                marginLeft: "10px",
              }}
              onClick={(e) => {
                if (!deleteAllowed) return;
                e.stopPropagation();
                setDeleteId(record?.TRIPID); // Set the ID of the consignment to delete
                setIsDeleteModalVisible(true); // Show the delete confirmation modal
              }}
            />
          </Tooltip>
        </div>
      ),
    },
  ];
  // Custom fields (selectable)
  const customFieldOptions = Array.isArray(customFields)
    ? customFields.map((field) => ({
        label: field.FIELDNAME,
        value: field.CFID,
        disabled: false,
      }))
    : [];

  const allColumnOptions = [...customFieldOptions];
  //combained column with custom fields and columns
  const combinedColumns = useMemo(() => {
    if (!customFields || customFields.length === 0) {
      return columns; // Return default columns if no custom fields
    }

    const dynamicCols = customFields.map((field) => ({
      title: field.FIELDNAME,
      dataIndex: field.FIELDNAME,
      key: field.CFID,
      sorter: false,
      render: (_, record) => record?.[field.CFID] ?? "-",
    }));

    return [...dynamicCols];
  }, [customFields]);

  const displayedColumns = useMemo(() => {
    const defaultCols = [...columns];
    const customCols = combinedColumns.filter((col) =>
      selectedColumns.includes(col.key),
    );
    const transporterIdx = defaultCols.findIndex(
      (col) => col.key === "SupName",
    );
    const actionsIdx = defaultCols.findIndex((col) => col.key === "actions");
    const beforeTransporter = defaultCols.slice(0, transporterIdx + 1);
    const afterTransporter = defaultCols.slice(transporterIdx + 1, actionsIdx);
    const actionsCol = defaultCols.slice(actionsIdx);
    return [
      ...beforeTransporter,
      ...customCols,
      ...afterTransporter,
      ...actionsCol,
    ];
  }, [columns, combinedColumns, selectedColumns]);

  const handleClose = () => {
    setDrawerOpen(false);
  };

  const [editformdata, setEditformdata] = useState({});
  const [editripdata, setedittripdata] = useState([]);

  const edittrip = async () => {
    try {
      const { data } = await CALL_API("POST", `ai/trip/updateInsert`, {
        Code: editformdata?.CODE,
        Remarks: editformdata?.remarks,
        Status: 4,
        // CrBy: userInfo?.UID,
        // TripType: editformdata?.triptype,
        TripId: editformdata?.TRIPID,
        ODOStart: editformdata?.odostart,
        ODOEnd: editformdata?.odoend,
      });
      await CustomeDataUpdate(editformdata?.TRIPID, editformdata);
      fetchTripListData();
      setDrawerOpen(false);
    } catch (error) {}
  };

  // useEffect(() => {
  //   edittrip();
  // }, []);
  const handleChangeedit = (e) => {
    const { value, name } = e.target;
    setEditformdata((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  const AddEditFormm = useMemo(() => {
    const mappedCustomFields = customFields?.map((field) => {
      const name = field.FIELDNAME?.replace(/\s+/g, "_").toLowerCase();
      const type = getFieldType(field.FIELDTYPE);
      let options;

      // For dropdowns, parse options from DATASOURCE or OPTIONS
      if (type === "selectwithvalue" && (field.DATASOURCE || field.OPTIONS)) {
        const source = field.DATASOURCE || field.OPTIONS;
        options = source
          .split(",")
          .map((opt) => ({
            label: opt.trim(),
            value: opt.trim(),
          }))
          .filter((opt) => opt.value); // Remove empty options
      }

      return {
        id: field.CFID,
        label: field.FIELDNAME,
        type,
        name,
        placeholder: field.FIELDNAME,
        maxLength: field.MAXLEN > 0 ? field.MAXLEN : undefined,
        validationRules: field.REQUIRED
          ? [{ required: true, message: `${field.FIELDNAME} is required` }]
          : [],
        value: formData[name],
        onChange: handleChange,
        ...(options ? { options } : {}),
      };
    });
    const customFieldRows = chunkArray(mappedCustomFields || [], 3);
    const staticFields = [
      [
        {
          id: 1,
          label: "Trip Type",
          type: "selectwithvalue",
          name: "triptype",
          placeholder: "GCS",
          style: "",
          options:
            userInfo?.MCID === 72
              ? PanTripTypeEnum?.map((item) => ({
                  label: item.name,
                  value: item.value,
                }))
              : TripTypeEnum?.map((item) => ({
                  label: item.name,
                  value: item.value,
                })),
          validationRules: [
            { required: true, message: "Trip Type is required" },
          ],
        },
        {
          id: 2,
          label: "ODO Start",
          type: "text",
          name: "odostart",
          placeholder: "Cargo",
          style: "",
          options: transporterList?.map((item) => ({
            label: item?.Name,
            value: item?.ID,
          })),
          validationRules: [
            { required: true, message: "ODO Start is required" },
          ],
        },
        {},
        {},
      ],
      [
        {
          id: 3,
          label: "ODO End",
          type: "text",
          name: "odoend",
          placeholder: "TQS Agency",
          style: "",
          options: transporterList?.map((item) => ({
            label: item?.Name,
            value: item?.ID,
          })),
          validationRules: [{ required: true, message: "ODO End is required" }],
        },
        {},
        {},
        {},
      ],
      [
        {
          id: 4,
          label: "Remarks",
          type: "textarea",
          name: "remarks",
          placeholder: "Daily Rate",
          style: "",
          validationRules: [
            { required: false, message: "Remarks is required" },
          ],
          colSpan: 24,
        },
        {},
      ],
      [
        {
          id: 5,
          label: "Fuel Quantity",
          type: "text",
          name: "finalquantity",
          placeholder: "High",
          style: "",
          options: priorityType?.map((item) => ({
            label: item?.name,
            value: item?.value,
          })),
          validationRules: [
            { required: false, message: "Fuel Quantity is required" },
          ],
        },
        {
          id: 6,
          label: "Trip Allowance",
          type: "text",
          name: "tripallowance",
          placeholder: "3",
          validationRules: [
            { required: true, message: "Trip Allowance is required" },
          ],
          style: "",
        },
        {},
        {},
      ],
    ];
    const allFields = [
      ...staticFields,
      ...customFieldRows.filter((row) =>
        row.some((field) => Object.keys(field).length > 0),
      ),
    ];

    return {
      totalpages: 1,
      pages: [
        {
          modalView: false,
          colSpan: [6],
          ...customFieldRows.map((row) => row.map(() => 6)),
          fields: allFields,
        },
      ],
    };
  }, [customFields, formData]);

  const tripType = [
    {
      label: "Local",
      value: 1,
    },
    { label: "safari", value: 2 },
  ];
  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
    { label: "---", value: "---" },
  ];
  const handleSelectChange = (field, value) => {
    setCurrentPage(1);
    setFormData((prevData) => ({
      ...prevData,
      [value]: field,
    }));
  };
  const filteredVehicles = vehicleLists
    ?.filter((item, index) => {
      return item?.FAgentGUID === "79ed738d-1788-4114-87e9-137c7f9ab149";
    })
    .map((item) => item.FVehicleName);
  useEffect(() => {}, [vehicleLists]);

  const editSelectChange = (field, value) => {
    setEditformdata((prevData) => ({
      ...prevData,
      [value]: field,
    }));
  };

  const ModalForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [6],
        fields: [
          [
            {
              id: 1,
              label: <span style={{ color: "#5F6D8C" }}>Trip Code</span>,
              type: "text",
              name: "tripcode",
              placeholder: "234123",
              maxLength: 50,
            },
            {
              id: 2,
              label: <span style={{ color: "#5F6D8C" }}>Trip Type</span>,
              type: "selectwithvalue",
              name: "triptype",
              placeholder: "Local",
              allowClear: true,
              maxLength: 50,
              options:
                userInfo?.MCID === 72
                  ? PanTripTypeEnum?.map((item) => ({
                      label: item.name,
                      value: item.value,
                    }))
                  : TripTypeEnum?.map((item) => ({
                      label: item.name,
                      value: item.value,
                    })),
            },
            {
              id: 3,
              label: <span style={{ color: "#5F6D8C" }}>Vehicle</span>,
              type: "selectwithvalue",
              name: "vehicle",
              allowClear: true,
              placeholder: "KA23134",
              maxLength: 50,
              // options: vehicleLists?.map((item) => ({
              //   label: item.FVehicleName,
              //   value: item.FVehicleName,
              // })),
              options: AIVehicleLists?.map((item) => ({
                value: item?.FGUID,
                label: item?.FVehicleName,
              })),
            },

            {
              id: 9,
              label: <span style={{ color: "#5F6D8C" }}>Driver</span>,
              type: "selectwithvalue",
              name: "driver",
              placeholder: "Tony",
              maxLength: 50,
              options: AIVehicleLists?.filter((item) => item?.FDriverName) // only include items with driver name
                .map((item) => ({
                  value: item?.FGUID,
                  label: item?.FDriverName,
                })),
            },
          ],
          [
            {
              id: 5,
              label: (
                <span style={{ color: "#5F6D8C" }}>Consignment Event</span>
              ),
              type: "selectwithvalue",
              name: "consignmentevent",
              placeholder: "Accepted",
              maxLength: 50,
              allowClear: true,
              options: AITripStatusEnum?.map((item) => ({
                label: item.label,
                value: item.value,
              })),
            },
            {
              id: 6,
              label: <span style={{ color: "#5F6D8C" }}>Consignor</span>,
              type: "selectwithvalue",
              name: "consignor",
              placeholder: "Accepted",
              allowClear: true,
              maxLength: 50,
              options: consignerList?.map((item) => ({
                label: item.Name,
                value: item.Name,
              })),
            },
            {
              id: 7,
              label: <span style={{ color: "#5F6D8C" }}>Transporter</span>,
              type: "selectwithvalue",
              name: "transporter",
              placeholder: "Accepted",
              allowClear: true,
              maxLength: 50,
              options: transporterList?.map((item) => ({
                label: item.Name,
                value: item.Name,
              })),
            },
            {
              id: 8,
              label: <span style={{ color: "#5F6D8C" }}>Consignee</span>,
              type: "selectwithvalue",
              name: "fence",
              placeholder: "TQS Agency",
              maxLength: 50,
              allowClear: true,
              options: fenceList?.map((item) => ({
                label: item.FName,
                value: item.FGUID,
              })),
            },
          ],
          [
            {
              id: 9,
              label: <span style={{ color: "#5F6D8C" }}>Duration</span>,
              type: "selectwithvalue",
              name: "duration",
              placeholder: "Current Month",
              maxLength: 50,
              allowClear: true,
              options: Duration?.map((item) => ({
                label: item.label,
                value: item.value,
              })),
            },
            {
              id: 10,
              label: <span style={{ color: "#5F6D8C" }}>Date Range</span>,
              type: "daterange",
              name: "daterange",
              placeholder: "24th Aug 2024 - 24th Sep 2024",
              maxLength: 50,
            },
          ],
          ...(userInfo?.MCID === 72
            ? [
                [
                  {
                    id: 11,
                    label: (
                      <span style={{ color: "#5F6D8C" }}>Reference Number</span>
                    ),
                    type: "text",
                    name: "ReferenceNo",
                    maxLength: 50,
                  },
                  {},
                ],
              ]
            : []),
        ],
      },
    ],
  };

  const handleclick = (record) => {
    setConsignee(true);
  };
  const handleSubmitForm = async () => {};

  const [checkedList, setCheckedList] = useState([]);

  const onCheckAllChange = (e) => {
    const isChecked = e.target.checked;
    setSortFields(isChecked ? allOptions : []);
    setSortColumns(
      isChecked ? allOptions.map((col) => ({ column: col, order: "ASC" })) : [],
    );
  };

  const allOptions = [
    "CODE",
    "VehRegNo",
    "CustName",
    "SupName",
    "ReferenceNo",
    "ContainerNo",
    "FWayBill",
  ];
  const handleSortOptionsChange = (checkedValues) => {
    setSortFields(checkedValues);
    // Keep existing orders, add new ones as ASC, remove unchecked
    setSortColumns((prev) => {
      const kept = prev.filter((sc) => checkedValues.includes(sc.column));
      const added = checkedValues
        .filter((col) => !prev.find((sc) => sc.column === col))
        .map((col) => ({ column: col, order: "ASC" }));
      return [...kept, ...added];
    });
  };
  const toggleSortOrder = (column) => {
    setSortColumns((prev) =>
      prev.map((sc) =>
        sc.column === column
          ? { ...sc, order: sc.order === "ASC" ? "DESC" : "ASC" }
          : sc,
      ),
    );
  };
  const sortOptionLabels = [
    { value: "CODE", label: "Trip Code" },
    { value: "VehRegNo", label: "Vehicle" },
    { value: "CustName", label: "Consignor" },
    { value: "SupName", label: "Transporter" },
    { value: "ReferenceNo", label: "Reference No" },
    { value: "ContainerNo", label: "Container Number" },
    { value: "FWayBill", label: "Delivery Note Number" },
  ];

  const content = (
    <WrapperBox>
      <div className="checkbox_group_container">
        <div class="d-flex align-items-center justify-content-between border-bottom pb-2 ">
          <Checkbox
            onChange={onCheckAllChange}
            checked={sortFields.length === sortOptionLabels.length}
          >
            All
          </Checkbox>
          {sortFields.length > 0 && (
            <Button
              style={{ color: "#28a745", border: "0px" }}
              onClick={() => {
                setSortColumns([]);
                setSortFields([]);
              }}
            >
              Reset
            </Button>
          )}
        </div>
        <Checkbox.Group value={sortFields} onChange={handleSortOptionsChange}>
          <div className="checkbox_group_container">
            {sortOptionLabels.map(({ value, label }) => (
              <div
                key={value}
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <Checkbox value={value}>{label}</Checkbox>
                {sortFields.includes(value) && (
                  <span
                    onClick={() => toggleSortOrder(value)}
                    style={{
                      cursor: "pointer",
                      fontSize: "11px",
                      color: "#2C963D",
                      fontWeight: 600,
                      border: "1px solid #2C963D",
                      borderRadius: "4px",
                      padding: "1px 5px",
                      userSelect: "none",
                    }}
                  >
                    {sortColumns.find((sc) => sc.column === value)?.order ??
                      "ASC"}
                  </span>
                )}
              </div>
            ))}
          </div>
        </Checkbox.Group>
      </div>
    </WrapperBox>
  );

  useEffect(() => {
    GetAllCustomeData();
  }, []);

  useEffect(() => {
    if (AllCustomeData && AllCustomeData.length > 0) {
      loadCustomFields();
    }
  }, [AllCustomeData]);

  useEffect(() => {
      fetchTripListData();
  }, [customFields, 
    formData?.driver,
    formData?.consignor,
    formData?.vehicle,
    formData?.consignee,
    formData?.fence,
    formData?.transporter,
    formData?.consignmentevent,
    formData?.ReferenceNo,
    formData?.tripcode,
    formData?.triptype,
    formData?.daterange,
  ]);
  useEffect(() => {
    fetchTripListData(currentPage, pageSize);
  }, [currentPage, pageSize]);

  useEffect(() => {
    if (sortColumns.length > 0) {
      fetchTripListData();
    }
  }, [sortColumns]);

  useEffect(() => {
    const count = Object.values(formData).filter(
      (val) => val && val.length !== 0,
    ).length;

    setFilterCount(count);
  }, [formData]);
  const isDataReady =
    typeof loading !== "undefined"
      ? !loading
      : Boolean(total || completedCount || inProgressCount || assignedCount);

  const [selectededittwo, setSelectededittwo] = useState();
  return (
    <>
      <UIModal
        width={1200}
        open={showModal}
        onClose={handlecancelmodal}
        closeButton={false}
        size="lg"
        header={
          <WrapperBox>
            <Row>
              <Col xl={24} sm={24}>
                <div className="modal_container_forfiltermenu">
                  <span className="flilter_five">Filters ({filterCount})</span>
                  <span
                    style={{
                      color: "#2C963D",
                      fontWeight: "400",
                      fontSize: "20px",
                    }}
                  ></span>
                </div>
              </Col>
            </Row>
          </WrapperBox>
        }
        footer={
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <ButtonFilled onClick={editModuleupdate}>Clear All</ButtonFilled>
          </div>
        }
      >
        {/* This is the BODY section of the Modal */}
        <WrapperBox>
          <GridBuilder
            formStructureJson={ModalForm}
            handleChange={handleChange}
            formSubmit={handleSubmitForm}
            initialValues={formData}
            form={form}
            handleSelectChange={handleSelectChange}
          />
        </WrapperBox>
      </UIModal>

      {consignee ? (
        <>
          <TripCode
            fetchTripListData={fetchTripListData}
            setDrawerOpen={setDrawerOpen}
            setConsignee={setConsignee}
            AddEditFormm={AddEditFormm}
            handleChange={handleChange}
            handleSubmitForm={handleSubmitForm}
            handleClose={handleClose}
            drawerOpen={drawerOpen}
            formData={formData}
            WrapperBox={WrapperBox}
            tripId={tripId}
            ShipmentId={ShipmentId}
            selectededittwo={selectededittwo}
            vehId={VEHID}
          />
        </>
      ) : (
        <>
          <WrapperBox>
            <Row gutter={16}>
              <Col xs={24} xl={24}>
                <Row gutter={16}>
                  <Col xs={24} xl={24}></Col>
                </Row>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} xl={24}>
                <div className="consingment_container">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      flexWrap: "wrap",
                    }}
                  >
                    <p style={{ margin: 0 }}>{total} Trips</p>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "5px",
                        background: !isDataReady
                          ? "#E7E8E9"
                          : completedCount === 0
                            ? "#E7E8E9"
                            : "#33C24A2B",
                        borderRadius: "20px",
                        padding: "3px 10px",
                        fontSize: "12px",
                        color: !isDataReady
                          ? "#595959"
                          : completedCount === 0
                            ? "#595959"
                            : "#1a6b28",
                      }}
                    >
                      <span
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "50%",
                          background: !isDataReady
                            ? "#A8A8A8"
                            : completedCount === 0
                              ? "#595959"
                              : "#2C963D",
                          display: "inline-block",
                          flexShrink: 0,
                        }}
                      />
                      {isDataReady
                        ? `${completedCount} Completed`
                        : "0 Completed"}
                    </span>

                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "5px",
                        background: !isDataReady
                          ? "#E7E8E9"
                          : inProgressCount === 0
                            ? "#E7E8E9"
                            : "#BF901826",
                        borderRadius: "20px",
                        padding: "3px 10px",
                        fontSize: "12px",
                        color: !isDataReady
                          ? "#595959"
                          : inProgressCount === 0
                            ? "#595959"
                            : "#9a6800",
                      }}
                    >
                      <span
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "50%",
                          background: !isDataReady
                            ? "#A8A8A8"
                            : inProgressCount === 0
                              ? "#595959"
                              : "#E4A400",
                          display: "inline-block",
                          flexShrink: 0,
                        }}
                      />
                      {isDataReady
                        ? `${inProgressCount} In Progress`
                        : "0 In Progress"}
                    </span>

                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "5px",
                        background: !isDataReady
                          ? "#E7E8E9"
                          : assignedCount === 0
                            ? "#E7E8E9"
                            : "transparent",
                        borderRadius: "20px",
                        padding: "3px 10px",
                        fontSize: "12px",
                        color: !isDataReady
                          ? "#595959"
                          : assignedCount === 0
                            ? "#595959"
                            : "#E4A400",
                        border: !isDataReady
                          ? "none"
                          : assignedCount === 0
                            ? "none"
                            : "1px solid #E4A400",
                      }}
                    >
                      <span
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "50%",
                          background: !isDataReady
                            ? "#A8A8A8"
                            : assignedCount === 0
                              ? "#595959"
                              : "#E4A400",
                          display: "inline-block",
                          flexShrink: 0,
                        }}
                      />
                      {isDataReady ? `${assignedCount} Assigned` : "0 Assigned"}
                    </span>
                  </div>
                  <div className="consingment_container_two">
                    <div className="Custom">
                      <Tooltip
                        title={!exportAllowed ? "No permission" : ""}
                        placement="bottom"
                        visible={visibleExport}
                        onVisibleChange={handleTooltipVisibleChangeExport}
                        overlayInnerStyle={{
                          backgroundColor: "transparent",
                          color: "#5f6d8c",
                          boxShadow: "none",
                          padding: "0",
                        }}
                      >
                        <Spin spinning={CSVLoader}>
                          <img
                            src={ExportIcon}
                            alt="Export"
                            style={{
                              width: "20px",
                              height: "20px",
                              cursor: "pointer",
                              marginRight: "40px",
                              backgroundColor: "#EBF7ED",
                              borderRadius: "6px",
                            }}
                            onClick={() => {
                              if (!exportAllowed) return;
                              prepareCSV();
                            }}
                          />
                        </Spin>
                        <CSVLink
                          data={CSVList}
                          filename={"Trip List.csv"}
                          asyncOnClick={true}
                          ref={csvLinkEl}
                        />
                      </Tooltip>
                    </div>
                    <div className="Custom">
                      <Tooltip
                        title="Sort Column"
                        placement="bottom"
                        visible={visibleSort}
                        onVisibleChange={handleTooltipVisibleChangeSort}
                        overlayInnerStyle={{
                          backgroundColor: "transparent",
                          color: "#5f6d8c",
                          boxShadow: "none",
                          padding: "0",
                        }}
                      >
                        <Popover content={content} trigger="click">
                          <img
                            src={SortIcon}
                            alt="Sort"
                            style={{
                              width: "20px",
                              height: "25px",
                              cursor: "pointer",
                              marginRight: "30px",
                              backgroundColor: "#EBF7ED",
                              borderRadius: "6px",
                            }}
                            onClick={(e) => e.preventDefault()}
                          />
                        </Popover>
                      </Tooltip>
                    </div>
                    <Badge
                      count={filterCount}
                      className="badg"
                      style={{ marginRight: "20px" }}
                    >
                      <Avatar
                        shape="circle"
                        size="small"
                        src={FilterIcon}
                        className="filterstyle"
                        onClick={handleclickme}
                        style={{ marginRight: "20px" }}
                      />
                    </Badge>
                    {/* <ButtonOutlined
                      onClick={() => setIsconfigModalVisible(true)}
                      className="Create_btn"
                    >
                      Configure
                    </ButtonOutlined> */}
                  </div>
                </div>
              </Col>
            </Row>
          </WrapperBox>

          <TableStyle>
            <Row gutter={16}>
              <Col xl={24} xs={24}>
                <div>
                  <Spin spinning={loading}>
                    <StyledTable
                      className=""
                      pagination={false}
                      dataSource={tripList}
                      columns={displayedColumns}
                      onRow={(record) => ({
                        onMouseEnter: () => handleClickme(record),
                        onMouseLeave: () => setHoveredrow(null),
                        onClick: (e) => {
                          e.stopPropagation();
                          setConsignee(true);
                          setTripId(record?.TRIPID);
                          setShipmentId(record?.ShipmentType);
                          setVehId(record?.VehId);
                          setSelectededittwo(record);
                        },
                      })}
                    />
                    <ReusablePagination
                      pageSize={pageSize}
                      handlePageSizeChange={handlePageSizeChange}
                      currentPage={currentPage}
                      total={total}
                      handlePageChange={handlePageChange}
                    />
                  </Spin>
                </div>
              </Col>
            </Row>
          </TableStyle>

          <ReusableDrawer
            title=""
            open={drawerOpen}
            setOpen={setDrawerOpen}
            onClose={() => setDrawerOpen(false)}
            closable={false}
            footer={[
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: "15px",
                }}
              >
                <Button
                  key="cancel"
                  className="cancel-btn"
                  onClick={() => setDrawerOpen(false)}
                  style={{
                    borderRadius: "26px",
                    backgroundColor: "#E8FFEC",
                    color: "#2C963D",
                    borderColor: "#E8FFEC",
                    width: "118px",
                    height: "38px",
                  }}
                >
                  Cancel
                </Button>
                <ButtonFilled
                  key="create"
                  type="primary"
                  onClick={() => form?.submit()}
                >
                  {isEditing ? "Update" : "Create"}
                </ButtonFilled>
              </div>,
            ]}
          >
            <WrapperBox>
              <Row gutter={16}>
                <Col xl={24} xs={24}>
                  <div className="Creating_Consignment">
                    <p>Modifying Trip</p>

                    <span>
                      <CloseOutlined onClick={() => setDrawerOpen(false)} />
                    </span>
                  </div>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col xl={24} xs={24}>
                  <GridBuilder
                    formStructureJson={AddEditFormm}
                    handleChange={handleChangeedit}
                    formSubmit={edittrip}
                    initialValues={editformdata}
                    form={form}
                    handleSelectChange={editSelectChange}
                  />
                </Col>
              </Row>
            </WrapperBox>
          </ReusableDrawer>
          <UIModal
            className="modal_updatable"
            width={500}
            open={isDeleteModalVisible}
            onClose={() => {
              setIsDeleteModalVisible(false);
              setDeleteId(null); // Reset the delete ID
            }}
            closeButton={false}
            size="md"
            header={false}
            footer={false}
          >
            <div className="text-center">
              <h1>Are you sure,</h1>
              <h6>You want to delete this Trip?</h6>
              <div className="mt-2 w-100 d-flex justify-content-center">
                <ButtonFilled
                  loading={deleteloading}
                  onClick={() => {
                    handleclickdeleteAi(deleteId); // Call the delete function with the selected ID
                  }}
                >
                  Yes
                </ButtonFilled>
                <Buttontransparent
                  onClick={() => {
                    setIsDeleteModalVisible(false); // Close the modal
                    setDeleteId(null); // Reset the delete ID
                  }}
                >
                  No
                </Buttontransparent>
              </div>
            </div>
          </UIModal>
          <UIModal
            width={600}
            height={600}
            open={isconfigModalVisible}
            onClose={() => {
              setIsconfigModalVisible(false);
            }}
            closeButton={false}
            size="md"
            header={
              <div className="text-start">
                <h2>Customized Column</h2>
                <label
                  style={{
                    marginBottom: 8,
                    display: "block",
                    color: "#5F6D8C",
                  }}
                >
                  Columns
                </label>
              </div>
            }
            footer={
              <div className="mt-2 w-100 d-flex justify-content-end">
                <ButtonFilled
                  onClick={() => {
                    setIsconfigModalVisible(false); // Close the modal
                  }}
                >
                  Save
                </ButtonFilled>
                <Buttontransparent
                  onClick={() => {
                    setIsconfigModalVisible(false); // Just close the modal
                  }}
                >
                  Cancel
                </Buttontransparent>
              </div>
            }
          >
            <Select
              mode="multiple"
              style={{ width: "100%" }}
              placeholder="Select custom columns"
              value={selectedColumns}
              onChange={setSelectedColumns}
              dropdownStyle={{ maxHeight: 250, overflow: "auto" }}
              dropdownRender={(menu) => (
                <div>
                  <Checkbox.Group
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      padding: "8px 12px",
                    }}
                    value={selectedColumns}
                    onChange={setSelectedColumns}
                  >
                    {allColumnOptions.map((option) => (
                      <Checkbox
                        key={option.value}
                        value={option.value}
                        disabled={option.disabled}
                      >
                        {option.label}
                      </Checkbox>
                    ))}
                  </Checkbox.Group>
                </div>
              )}
            >
              {allColumnOptions.map((option) => (
                <Select.Option
                  key={option.value}
                  value={option.value}
                  disabled={option.disabled}
                >
                  {option.label}
                </Select.Option>
              ))}
            </Select>
          </UIModal>
        </>
      )}
    </>
  );
};

export default TripListAI;
